import moment from "moment"
import { cellValueExcel, RowExportTypeExcel } from "types"
import { excel } from "utils"
import { RegisterReconcileList } from "../types"

export function ExportExcel(props: {
    data: RegisterReconcileList[],
    filter: {
        dateFrom: string,
        dateTo: string
    },
    title: string,
    fileName: string
}) {
    const columns = [
        { header: "NO", key: "no", width: 5 },
        { header: "RCL ID#", key: "rcl_id", width: 20 },
        { header: "BY", key: "by", width: 20 },
        { header: "NEW STATEMENT DATE", key: "new_statement_date", width: 50 },
        { header: "LAST RECONCILE DATE", key: "last_reconcile_date", width: 50 },
        { header: "NEW STATEMENT BALANCE", key: "new_statement_balance", width: 50 },
        { header: "LAST STATEMENT BALANCE", key: "last_statement_balance", width: 50 },
        { header: "TOTAL CLEARED DEBET", key: "total_cleared_debet", width: 50 },
        { header: "TOTAL CLEARED CREDIT", key: "total_cleared_credit", width: 50 },
        { header: "OUT OF BALANCE", key: "out_of_balance", width: 50 },
    ]

    const dataMap: RowExportTypeExcel[] = props.data.map((item, index) => {

        return {
            no: index + 1,
            rcl_id: item.reconciliation_code,
            by: item.created_by_name,
            new_statement_date: moment(item.new_statement_date).format("DD/MM/YYYY"),
            last_reconcile_date: moment(item.last_reconciliation_date).format("DD/MM/YYYY"),
            new_statement_balance: numberFormat(item.new_statement_balance),
            last_statement_balance: numberFormat(item.last_statement_balance),
            total_cleared_debet: numberFormat(item.total_cleared_debet),
            total_cleared_credit: numberFormat(item.total_cleared_credit),
            out_of_balance: numberFormat(item.out_of_balance)
        }
    })

    excel({
        dataList: dataMap,
        column: columns,
        title: props.title,
        module: "FINANCE",
        fileName: props.fileName,
        date: `${moment(props.filter.dateFrom).format('DD-MM-YYYY')} - ${moment(props.filter.dateTo).format('DD-MM-YYYY')}`
    })
}

function numberFormat (value: number) : cellValueExcel  {
    return {
        text: value,
        style: {
            alignment: {
                horizontal: "right"
            },
            numFmt: "#,##0"
        }
    }
}